import mainSlider from './mainSlider'; // SLIDESHOW IMPORTED

export default function () {
  const widgetName = 'videoWidget';
  let widgetOpts;

  if ($('body').hasClass('hooplandiaHomepage')) {
    $('.hooplandiaYoutubeVideo').append('<iframe></iframe>');
    $('.hooplandiaYoutubeVideo').wrap('<div id="hooplandiaYoutubeVideo"></div>');
    $('.hooplandiaYoutubeVideo').attr('id', 'videoWidget');
    $('#hooplandiaYoutubeVideo').appendTo('.subpage-hoop-container .tier-one .video-wrap')

    widgetOpts = videoWidgetOptsSpecial;

    $(`#${widgetName}`).videoWidget({
      scriptPath: widgetOpts.scriptPath
      , currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID
      , detectIpad: IPADDETECTED
      // options
      , multiVideo: false
      , showOnMobile: true
      , maxVideos: 1
      , trackingGA: {
        present: false,
        event: 'event',
        gaObj: {
          eventCategory: 'Videos',
          eventAction: '',
          eventLabel: '',
        }
      }
      , videoWidgetLoaded: function (data) {

        // checking if there are content on video widget
        if (data.Slides.length > 0) {

          // autoplay and loop settings for hero banner video
          let autoplay = true;
          let autoplayString = "?rel=0&loop=1&showcontrols=0&showinfo=0&controls=0&autoplay=1&mute=1&playlist=";

          if (autoplay) {
            autoplayString = autoplayString;
          } else {
            autoplayString = "";
          }

          let videoSrc = $('#videoWidget iframe').attr('src');
          let getVideoCode = /embed\/([a-zA-Z0-9_-]+)\?/;
          let match = videoSrc.match(getVideoCode);
          let videoCodeUpdated = match ? match[1] : null;

          $('#videoWidget iframe').attr('src', `https://www.youtube.com/embed/${videoCodeUpdated}${autoplayString}${videoCodeUpdated}`)

          // if there is a video, it will remove the slideshow
          $('#slideshow-wrap').remove()
          $('#hoopMainSlideshow').remove()

        } else {
          // if no video loaded on widget, it removes the container and keeps the slideshow
          $(this).remove()
          $('.tier-one .video-wrap').remove()
        }


      }
    });

  } else {

    // Static html video condition
      const eventsMode = $('body').hasClass('eventsMode');

    if (eventsMode ) {
      mainSlider();
    } else  {
      $('#mainSlider').remove();
      $('#main-feature-section').append(`
        <div id="htmlVideoContainer">
          <video muted="" playsinline="" autoplay="" loop="" poster="" role="presentation" id="hero-video">
            <source src="${FULLCLIENTTHEMEPATH}static/BigERecap2024.mp4?sv=${SITEVERSION} type="video/mp4">
            Your browser does not support the video tag.
          </video>
        </div>
       `)
    }




    
  // $(`#${widgetName}`).append('<iframe></iframe>');
  // $(`#${widgetName}`).wrap('<div id="videoSection"></div>');
  // widgetOpts = videoWidgetOpts;
  // $(`#${widgetName}`).videoWidget({
  //   scriptPath: widgetOpts.scriptPath,
  //   currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
  //   detectIpad: IPADDETECTED,
  //   // options
  //   multiVideo: false,
  //   showOnMobile: true,
  //   maxVideos: 1,
  //   autoPlayVideo: false,
  //   loopVideo: false,
  //   videoWidgetLoaded: function (data) {
  //     const eventsMode = $('body').hasClass('eventsMode');
  //     const isData = data.Slides.length > 0;
  //     let autoplay = '';
  //     let showControls = '';
  //     let loopVideo = '';
  //     let videoStartTime = '';
  //     let autoplayString = '';
  //     let videoSrc = '';
  //     let getVideoCode = '';
  //     let match = '';
  //     let videoCodeUpdated = '';

  //     if (isData) {
  //       autoplay = true;
  //       showControls = false;
  //       loopVideo = true;

  //       videoStartTime = 0; // <<<< Time start to video (requires autoplay:true on widget settings)

  //       // ----------- //

  //       autoplayString = `?rel=0&loop=${loopVideo ? '1' : '0'}&showcontrols=${
  //         showControls ? '1' : '0'
  //       }&showinfo=0&controls=${showControls ? '1' : '0'}&autoplay=${
  //         autoplay ? '1' : '0'
  //       }&mute=1&playlist=`;

  //       videoSrc = $('#videoWidget iframe').attr('src');
  //       getVideoCode = /embed\/([a-zA-Z0-9_-]+)\?/;
  //       match = videoSrc.match(getVideoCode);
  //       videoCodeUpdated = match ? match[1] : null;
  //     }
  //     if (eventsMode || !isData) {
  //       mainSlider();
  //       $('#videoSection').remove();
  //     } else if (isData && !eventsMode) {
  //       $('#mainSlider').remove();
  //       $('#videoWidget iframe').attr(
  //         'src',
  //         `https://www.youtube.com/embed/${videoCodeUpdated}${autoplayString}${videoCodeUpdated}${
  //           videoStartTime === 0 ? '' : `&amp;start=${videoStartTime}`
  //         }`
  //       );
  //     }
  //     if (!eventsMode && !isData) {
  //       $('#videoSection').remove();
  //     }
  //   },
  // });
  }

}
